import User from "@/helpers/models/user.model";

/** True only when storage/API explicitly set isProfileCompleted to true. */
export function isProfileCompleted(user: User | null | undefined): boolean {
  return user?.isProfileCompleted === true;
}

/** Logged-in non-guest users who must finish create-profile onboarding. */
export function requiresProfileOnboarding(user: User | null | undefined): boolean {
  if (!user?._id) {
    return false;
  }
  if (user.isGuestUser) {
    return false;
  }
  return !isProfileCompleted(user);
}

/** Routes reachable while profile onboarding is incomplete. */
export const PROFILE_ONBOARDING_ALLOWED_ROUTE_NAMES = new Set([
  "createProfile",
  "keycloak-callback",
  "twitter",
  "linkedIn",
  "reddit",
  "x",
  "platform",
  "otpVerification",
  "locked",
  "accountBanned",
]);
